import * as THREE from 'three'
import type { InputState } from './input'
import type { RawScript } from './playback'

// In-game recorder: press F9 to start, F9 again to stop + download the JSON fixture.
// Respawn (R) before starting so the recorded spawn matches the test spawn.
// Load the downloaded JSON in a test with runRawScript() / recordRawScript().
export class Recorder {
  private recording = false
  private spawn: THREE.Vector3 | null = null
  private inputs: InputState[] = []

  get isRecording(): boolean {
    return this.recording
  }

  start(spawn: THREE.Vector3): void {
    this.spawn = spawn.clone()
    this.inputs = []
    this.recording = true
    console.info('[recorder] started — press F9 to stop and download')
  }

  // Call once per physics tick while recording is active.
  tick(input: InputState): void {
    if (!this.recording) return
    this.inputs.push({ ...input })
  }

  // Stop recording and return the script (without downloading).
  stop(): RawScript | null {
    if (!this.spawn) return null
    this.recording = false
    return {
      spawn: [this.spawn.x, this.spawn.y, this.spawn.z],
      inputs: this.inputs,
    }
  }

  // Stop recording and trigger a browser download of the JSON fixture.
  export(): void {
    const script = this.stop()
    if (!script) return
    const json = JSON.stringify(script)
    const blob = new Blob([json], { type: 'application/json' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = `run-${Date.now()}.json`
    a.click()
    URL.revokeObjectURL(url)
    console.info(`[recorder] exported ${script.inputs.length} ticks`)
  }
}
